// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Vn-z","badgeLink":"Wn-z","category":"Xn-z"};